import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { AlertCircle, ExternalLink } from 'lucide-react';

/**
 * ExamLesson — lesson_type==='exam' icin placeholder.
 * Gercek sinav akisi ExamPage.js uzerinden yurutuluyor.
 * Bu bileşen kullaniciya yonlendirme saglar.
 *
 * @param {{ lesson: Object, courseId: string }} props
 */
export default function ExamLesson({ lesson: _lesson, courseId }) {
  const navigate = useNavigate();
  const { lang } = useLanguage();

  return (
    <div className="card-clay p-8 text-center mb-6" data-testid="exam-lesson-redirect">
      <div className="w-16 h-16 rounded-2xl bg-amber-50 flex items-center justify-center mx-auto mb-4">
        <AlertCircle size={32} className="text-amber-500" />
      </div>
      <h2 className="font-display text-2xl font-bold mb-2">
        {lang === 'tr' ? 'Sınav' : 'Exam'}
      </h2>
      <p className="text-sm text-[var(--text-muted)] font-semibold mb-6 max-w-sm mx-auto">
        {lang === 'tr'
          ? 'Bu ders bir sınav içeriyor. Sınav sayfasına giderek başlatabilirsiniz.'
          : 'This lesson contains an exam. You can start it from the exam page.'}
      </p>
      <button
        onClick={() => navigate(`/exam/${courseId}`)}
        className="btn-primary px-8 py-3 flex items-center gap-2 mx-auto"
        data-testid="go-to-exam-btn"
      >
        <ExternalLink size={18} />
        {lang === 'tr' ? 'Sınava Git' : 'Go to Exam'}
      </button>
    </div>
  );
}
